// Small math + helper grab-bag shared across modules.

export const clamp = (v, a, b) => (v < a ? a : v > b ? b : v);
export const lerp = (a, b, t) => a + (b - a) * t;
export const rnd = (a, b) => a + Math.random() * (b - a);
export const rndi = (a, b) => Math.floor(rnd(a, b + 1));
export const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];
export const deg2rad = (d) => (d * Math.PI) / 180;

// Seeded PRNG (mulberry32). Returns a function producing [0,1). Used to make a
// dungeon floor's generation fully reproducible so a saved run can regenerate
// the exact same map + enemy layout on resume.
export function makeRng(seed) {
  let a = seed >>> 0;
  return function () {
    a |= 0; a = (a + 0x6D2B79F5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

// In-place array compaction — keep elements where keep(el) is truthy, drop the
// rest, WITHOUT allocating a new array (unlike Array.filter). keep() may run a
// side-effect (dispose/remove) on elements it drops. Used in per-frame hot loops.
export function pruneInPlace(arr, keep) {
  let w = 0;
  for (let i = 0; i < arr.length; i++) { const el = arr[i]; if (keep(el)) arr[w++] = el; }
  arr.length = w;
}

// Shortest signed angle from a to b (radians), for smooth turning.
export function angleLerp(a, b, t) {
  let diff = ((b - a + Math.PI) % (Math.PI * 2)) - Math.PI;
  if (diff < -Math.PI) diff += Math.PI * 2;
  return a + diff * t;
}

// Weighted random pick from [{weight}] entries.
export function weightedPick(list) {
  const total = list.reduce((s, e) => s + e.weight, 0);
  let n = Math.random() * total;
  for (const e of list) {
    if (n < e.weight) return e;
    n -= e.weight;
  }
  return list[0];
}
